// older safari versions (< 16) have AbortSignal but not the timeout() method
if ('AbortSignal' in globalThis && !('timeout' in AbortSignal)) {
  ;(AbortSignal as any).timeout = (milliseconds: number) => {
    const controller = new AbortController()

    setTimeout(
      () =>
        controller.abort(
          new DOMException(
            `This signal is timeout in ${milliseconds}ms`,
            'TimeoutError',
          ),
        ),
      milliseconds,
    )

    return controller.signal
  }
}

if ('AbortSignal' in globalThis && !('any' in AbortSignal)) {
  ;(AbortSignal as any).any = (
    signals: AbortSignal[] | Iterable<AbortSignal>,
  ) => {
    const controller = new AbortController()

    function abort(this: AbortSignal) {
      controller.abort(this.reason)
      clean()
    }

    function clean() {
      for (const signal of signals) signal.removeEventListener('abort', abort)
    }

    for (const signal of signals)
      if (signal.aborted) {
        controller.abort(signal.reason)
        break
      } else signal.addEventListener('abort', abort)

    return controller.signal
  }
}
